import type { ComponentProps } from 'react';

import { clsxm } from '@vs-shop/utils';

export const IconMailCustomerSupport = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg
    data-slot="icon-mail-customer-support"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
    className={clsxm('size-5', className)}
    {...props}
  >
    <path
      d="M9.9974 0.833496L17.5391 5.3335C17.7891 5.48627 17.9835 5.69461 18.1224 5.9585C18.2613 6.22238 18.3307 6.50016 18.3307 6.79183V15.8335C18.3307 16.2918 18.1675 16.6842 17.8411 17.0106C17.5148 17.337 17.1224 17.5002 16.6641 17.5002H3.33073C2.8724 17.5002 2.48003 17.337 2.15365 17.0106C1.82726 16.6842 1.66406 16.2918 1.66406 15.8335V6.79183C1.66406 6.50016 1.73351 6.22238 1.8724 5.9585C2.01128 5.69461 2.20573 5.48627 2.45573 5.3335L9.9974 0.833496ZM9.9974 10.5418L16.4974 6.66683L9.9974 2.79183L3.4974 6.66683L9.9974 10.5418Z"
      fill="currentColor"
    />
  </svg>
);
